import { useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import RequireIcon from "../../components/RequireIcon";
import axios from 'axios';

export default function ContactDeleteMemberPage() {

    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [birth, setBirth] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const clickSubmit = async () => {
        const mobileRegex = /^01[016789]-?\d{3,4}-?\d{4}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        try {
            setIsLoading(true);

            if (!name || !mobile || !email || !birth) {
                alert('필수 값이 누락되었습니다. 입력해주세요.')
            }
            else if (!mobileRegex.test(mobile)) {
                alert('전화번호 형식을 확인해주세요.')
            }
            else if (!emailRegex.test(email)) {
                alert('이메일 형식을 확인해주세요.')
            }
            else {
                const mailTitle = `[링콜 랜딩페이지 회원탈퇴 요청]`;
                const mailContent = 
`
이름: ${name}
전화번호: ${mobile}
이메일: ${email}
생년월일: ${birth}

링콜 회원 탈퇴 요청
`    
                const data = {
                    title: mailTitle,
                    content: mailContent,
                }

                const res = await axios('https://3lmr55rji6zw63vfz2h6gbubju0tbtua.lambda-url.ap-northeast-2.on.aws', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                });

                alert('작성해주신 내용이 정상적으로 등록되었습니다.');
            }
        }
        catch(e) {
            console.log(e);
            alert('문의 접수가 실패했습니다. 다시 시도해 주세요.');
        }
        finally {
            setIsLoading(false);
        }
    }
  

    return (
        <div>
            <Header/>
            <main className='wrapper top-space bottom-space'>
                <h1 className='text-title2 lg:text-display1 text-center'>회원 탈퇴 요청하기</h1>
                <div className='mt-[20px] text-center text-label-200'>
                    회원 탈퇴를 원하시는 경우, 아래 정보를 입력하신 후 [요청하기] 버튼을 눌러주세요.<br/>
                    관리자가 확인한 후, 탈퇴 절차가 진행됩니다.<br/>
                    <br/>
                    약 3일이 소요되며, 완료 후 등록된 이메일로 결과를 안내해 드립니다.
                </div>

                <hr className='my-[80px]'/>

                <div className="flex flex-col text-body1 lg:text-heading2 text-label-200 [&>label]:mt-[30px] [&>label]:mb-[10px]">
                    <label htmlFor="name">이름<RequireIcon/></label>
                    <input type="text" id="name" placeholder="이름을 입력해주세요." autoComplete='name'
                            required maxLength={10}
                            value={name} onChange={(e) => setName(e.target.value)}/>

                    <label htmlFor="mobile">전화번호<RequireIcon/></label>
                    <input type="text" id="namobileme" placeholder="전화번호를 입력해주세요." autoComplete='mobile'
                            required maxLength={15}
                            value={mobile} onChange={(e) => setMobile(e.target.value)}/>

                    <label htmlFor="name">생년월일<RequireIcon/></label>
                    <input type="number" id="birth" placeholder="생년월일을 입력해주세요." autoComplete='birth'
                            required maxLength={10} 
                            value={birth} onChange={(e) => setBirth(e.target.value)}/>

                    <label htmlFor="email">이메일<RequireIcon/></label>
                    <input type="text" id="email" placeholder="이메일을 입력해주세요." autoComplete='email'
                            required maxLength={200}
                            value={email} onChange={(e) => setEmail(e.target.value)}/>
                </div>
                <div className='mt-[80px]'>
                    <button className=" w-full py-[16px] lg:py-[30px] text-heading1" disabled={isLoading} onClick={clickSubmit}>
                        요청하기
                    </button>
                </div>
            </main>
            <Footer/>
        </div>
    )
}